import moment from 'moment';
export default class TMS {
  constructor({
    id,
    index,
    customerName,
    customerEmail,
    customerMobile,
    correctiveMeasures,
    ticketOwner,
    assignedBy,
    platformType,
    storeId,
    storeName,
    region,
    state,
    city,
    storeManager,
    referenceNumber,
    billDate,
    billNumber,
    assignToStore,
    feedbackType,
    feedbackClass,
    feedbackSubClass,
    supportingImageUrl,
    attachmentURL,
    regionForComplain,
    storeResolution,
    storeReason,
    rca,
    timeOfStoreResolutionByStore,
    action,
    share_your_feedback,
    openSince,
    ticketNumber,
    modifiedBy,
    convoxFormType,
    department,
    team,
    updatedAt
  }) {
    this.id = id || '';
    this.index = index + 1;
    this.customerName = customerName || '';
    this.customerMobile = customerMobile || '';
    this.customerEmail = customerEmail || '';
    this.ticketOwner = ticketOwner || '';
    this.assignedBy = assignedBy || '';
    this.platformType = platformType || '';
    this.storeId = storeId || '';
    this.storeName = storeName || '';
    this.region = region || '';
    this.state = state || '';
    this.city = city || '';
    this.storeManager = storeManager || '';
    this.referenceNumber = referenceNumber || '';
    this.billDate = billDate ? moment(billDate).format('DD-MM-YYYY') : null;
    this.billNumber = billNumber || '';
    this.assignToStore = assignToStore || '';
    this.feedbackType = feedbackType || '';
    this.feedbackClass = feedbackClass || '';
    this.feedbackSubClass = feedbackSubClass || '';
    this.supportingImageUrl = supportingImageUrl || '';
    this.attachmentURL = attachmentURL || '';
    this.regionForComplain = regionForComplain || '';
    this.storeResolution = storeResolution || '';
    this.storeReason = storeReason || '';
    this.rca = rca || '';
    this.correctiveMeasures = correctiveMeasures || '';
    this.timeOfStoreResolutionByStore = timeOfStoreResolutionByStore
      ? moment(timeOfStoreResolutionByStore).format('DD-MM-YYYY')
      : null;
    this.action = action || '';
    this.share_your_feedback = share_your_feedback || '';
    this.openSince = openSince || '';
    this.ticketNumber = ticketNumber || '';
    this.modifiedBy = modifiedBy || '';
    this.convoxFormType = convoxFormType || '';
    this.department = department || '';
    this.team = team || '';
    this.updatedAt = updatedAt ? moment(updatedAt).format('DD-MM-YYYY') : null;
  }
}
